// extracted by mini-css-extract-plugin
export default {"MainContainer":"Popup_MainContainer__KlBCy","Overlay":"Popup_Overlay__74y0R","ContentWrapper":"Popup_ContentWrapper__vOJ5i","CloseIcon":"Popup_CloseIcon__ku4O+"};